/**
 * 与 src/thread/api/index.js 中 message.invoke("vue-recv-message" | "vue-recv-status") 配套。
 * 在 main.js 全局 install 一次即可，无需在 chat 页组件里重复 bindBy。
 */
export function installChatMessageRecvBridge(eapi, store) {
    if (!eapi || typeof eapi.bindBy !== "function" || !store) {
        return;
    }
    eapi.bindBy(
        "vue-recv-status",
        async (params, call) => {
            call({ code: 1, status: store.state.api.sendStatus });
        },
        true
    );
    eapi.bindBy(
        "vue-recv-message",
        async (params, call) => {
            let { delta, tool_calls, tool, toolping, name } = params;
            if (delta) {
                if (delta.reasoning_content) {
                    store.commit("api/appendStreamDelta", {
                        role: "think",
                        text: delta.reasoning_content,
                    });
                } else if (delta.content) {
                    store.commit("api/appendStreamDelta", {
                        role: "assistant",
                        text: delta.content,
                    });
                } else if (delta.streamDone) {
                    store.commit("api/setSendStatus", 2);
                }
            } else if (tool_calls) {
                store.commit("api/addChatMessage", {
                    role: "assistant",
                    tool_calls: tool_calls,
                    content: `正在调用[${name}]函数`,
                });
            } else if (tool) {
                store.commit("api/setLastAssistantWithToolsContent", `调用[${name}]函数完毕`);
                store.commit("api/addChatMessage", {
                    role: "tool",
                    tool_call_id: tool.tool_calls.id,
                    content: JSON.stringify(tool.content),
                });
                // 继续调用由后端 sendMessage 内部的工具循环负责（避免前端递归触发多次 sendMessage 造成竞态/中断）
                store.commit("api/setSendStatus", 1);
            } else if (toolping) {
                store.commit("api/setToolping", {
                    role: "toolping",
                    content: toolping.content,
                });
            }
            call({ code: 1, msg: "接收成功" });
        },
        true
    );
}
